import React from 'react';
import Loading from '../Loading';
import Notification from '../../Entities/Notification';
import Pagination from '../Pagination';
import Client from '../../Entities/Client';


interface IProps {
    pages: number;
    currentPage: number;
    list: Notification[];
    error: string;
    onLoadMore: (clientId: number) => void;
    client?: Client | null;
    isLoading: boolean;
}

export default class NotificationList extends React.Component<IProps> {

    renderItem = (item: Notification) => {
        return (
            <tr>
                <td>{item.getId()}</td>
                <td>{item.getStringType()}</td>
                <td>{item.getTitle()}</td>
                <td>{item.getStatus()}</td>
            </tr>
        )
    }

    onPage = (page: number) => {
        this.props.onLoadMore(page);
    }

    render() {
        const { isLoading, list, client } = this.props;
        if (isLoading) {
            return <Loading />;
        }
        else {
            return (
                <>
                    <div className="app-title">
                        <div>
                            <h1><i className="fa fa-th-list"></i> Оповещеня</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8">
                            <div className="tile">

                                {client ?
                                    <>
                                        <h2 className="tile-title">Клиент: {client?.getPhoneNumber()}, {client?.getName()}</h2>
                                    </> : null}
                                <br />
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Тип</th>
                                            <th>Заголовок</th>
                                            <th>Статус</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {list.map(this.renderItem)}
                                    </tbody>
                                </table>
                                <Pagination
                                    onPage={this.onPage}
                                    pages={this.props.pages}
                                    current={this.props.currentPage} />
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-lg-6">
                        
                    </div> */}
                </>
            )
        }
    }
}